
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import PaymentsContent from "./components/PaymentsContent.vue";

export default defineComponent({
  name: "PaymentsPage",
  components: {
    BreadCrumb,
    PaymentsContent,
  },
});
